import React from "react";
import Navbar from "./Navbar";

const NavigationBar = ({
  open,
  setOpen,
  sections,
  showMinimizeButton,
  useCurrentPage,
  showAssistantSelector = true
}) => (
  <Navbar
    sections={sections}
    showAssistantSelector={showAssistantSelector}
    useCurrentPage={useCurrentPage}
    open={open}
    setOpen={setOpen}
    showMinimizeButton={showMinimizeButton}
  />
);

export default NavigationBar;
